var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 15.9C8.66667 15.8333 9.3 15.8 10.1 15.8C12.6333 15.8 14.5333 16.5333 15.8 18C17.1333 19.4 17.8 21.1667 17.8 23.3C17.8 25.5667 17.0333 27.4667 15.5 29C14.0333 30.5333 12 31.3 9.4 31.3C6.73333 31.3 4.6 30.5667 3 29.1C1.4 27.5667 0.6 25.3667 0.6 22.5C0.6 18.6333 1.76667 14.7333 4.1 10.8C6.43333 6.8 9.3 3.46666 12.7 0.799999L14.7 2.9C10.3667 7.5 8.2 11.8333 8.2 15.9ZM31.6 15.9C32.0667 15.8333 32.7 15.8 33.5 15.8C36.0333 15.8 37.9333 16.5333 39.2 18C40.5333 19.4 41.2 21.1667 41.2 23.3C41.2 25.5667 40.4333 27.4667 38.9 29C37.4333 30.5333 35.4 31.3 32.8 31.3C30.1333 31.3 28 30.5667 26.4 29.1C24.8 27.5667 24 25.3667 24 22.5C24 18.6333 25.1667 14.7333 27.5 10.8C29.8333 6.8 32.7 3.46666 36.1 0.799999L38.1 2.9C33.7667 7.5 31.6 11.8333 31.6 15.9Z",
    fill: "#008080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/“.b563712b106c6514c5d7a034bd96f2b0.svg";
export { ForwardRef as ReactComponent };